import React from "react";

const ResponsiveProjectLogo = ({
	project,
	alt = "",
	sizes = "96px",
	loading,
	fetchPriority,
	className,
}) => (
	<img
		src={project.logo}
		srcSet={project.logoSrcSet}
		sizes={project.logoSrcSet ? sizes : undefined}
		alt={alt}
		className={className}
		width="256"
		height="256"
		loading={loading}
		fetchPriority={fetchPriority}
		decoding="async"
	/>
);

export default ResponsiveProjectLogo;
